// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type BatchCreateDocumentFieldsMutationVariables = Types.Exact<{
  input: Types.BatchCreateDocumentFieldsInput;
}>;


export type BatchCreateDocumentFieldsMutation = { __typename?: 'Mutation', batchCreateDocumentFields: Array<{ __typename?: 'DocumentField', id: string, name: string, kind: Types.DocumentFieldKind, documentCollectionId: string }> };


export const BatchCreateDocumentFieldsDocument = gql`
    mutation BatchCreateDocumentFields($input: BatchCreateDocumentFieldsInput!) {
  batchCreateDocumentFields(input: $input) {
    id
    name
    kind
    documentCollectionId
  }
}
    `;

/**
 * __useBatchCreateDocumentFieldsMutation__
 *
 * To run a mutation, you first call `useBatchCreateDocumentFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateDocumentFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateDocumentFieldsMutation, { data, loading, error }] = useBatchCreateDocumentFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateDocumentFieldsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchCreateDocumentFieldsMutation, BatchCreateDocumentFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchCreateDocumentFieldsMutation, BatchCreateDocumentFieldsMutationVariables>(BatchCreateDocumentFieldsDocument, options);
      }
export type BatchCreateDocumentFieldsMutationHookResult = ReturnType<typeof useBatchCreateDocumentFieldsMutation>;
export type BatchCreateDocumentFieldsMutationResult = ApolloReactCommon.MutationResult<BatchCreateDocumentFieldsMutation>;